import { render } from "./dashboard_counts.vue?vue&type=template&id=1d4ef172&scoped=true"
import script from "./dashboard_counts.vue?vue&type=script&lang=js"
export * from "./dashboard_counts.vue?vue&type=script&lang=js"

import "./dashboard_counts.vue?vue&type=style&index=0&id=1d4ef172&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4ef172"]])

export default __exports__